const fetchData = (pageId: number): string => `
    {
    page(id: "${pageId}", idType: DATABASE_ID) {
      ServicesTemplate {
        titleServices
        descriptionServices
      }
    }
  }
`;
export default fetchData;

